import { inject, Injectable, InjectionToken } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';

import { VersionClient } from '../client/version.client';

@Injectable({ providedIn: 'root' })
export class VersionService {
  static readonly fetchAsap = new InjectionToken('VersionService.fetchAsap', {
    providedIn: 'root',
    factory: () => true,
  });
  private readonly versionClient = inject(VersionClient);

  private readonly version$ = this.versionClient.getVersion().pipe(shareReplay(1));

  constructor() {
    if (inject(VersionService.fetchAsap)) {
      // Trigger fetch ASAP
      this.version$.subscribe();
    }
  }

  /**
   * Returns the application version.
   * Fetches the version if it has not yet been fetched.
   * Waits until fetch is done before returning.
   *
   * @returns The application version.
   *          If undefined the version could not be loaded or is not yet loaded.
   */
  getVersion(): Observable<string | undefined> {
    return this.version$.pipe(map((version) => version?.['customer-data-frontend']));
  }
}
